var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56,
    viewBox: "0 0 80 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 56,
    rx: 16,
    fill: "#FF7E84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 26.2679C51.3333 27.0378 51.3333 28.9623 50 29.7321L36.5 37.5263C35.1667 38.2961 33.5 37.3338 33.5 35.7942L33.5 20.2058C33.5 18.6662 35.1667 17.7039 36.5 18.4737L50 26.2679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.4e88fa2294f523f9e0c1960496838fea.svg";
export { ForwardRef as ReactComponent };